export const MULTIPLIER_PRECISION = 2;
export const MULTIPLIER_STEP_VALUE = 1;
export const MULTIPLIER_MAX_LENGTH = 7;
export const WIN_CHANCE_PRECISION = 6;
export const WIN_CHANCE_STEP_VALUE = 1;
export const WIN_CHANCE_MAX_LENGTH = 8;
export const WIN_CHANCE_MAX_LENGTH1 = 9;
export const CRASH_RTP = 0.98;
export const CRASH_GAME_ID = 38;
export const CRASH_GAME_TYPE_ID = 279;
export const CRASH_MAX_OD_IN_CHART = 1.7;
export const CRASH_AUTO_CASH_OUT_MIN_ODD = 100;
export const CRASH_DEFAULT_WIN_CHANCE_VALUE = 19.6;

export const MULTIPLIER_LIMIT = {
  minBet: 1.01,
  maxBet: 9999999,
};

export const WIN_CHANCE_LIMIT = {
  minBet: 0.01,
  maxBet: 97,
};

export const crashCountdownDeductionValues = {
  deductionValue: 0.1,
  intervalDelay: 100,
  precision: 1,
};

export const crashDateConvertToYrMosDFormat = 'MM.DD.YYYY';

export const CRASH_RULES_KEYS = new Array(10).fill(null).map((item, index) => index + 1);
export const CRASH_ABOUT_HASH_KEYS = new Array(18).fill(null).map((item, index) => index + 1);
